/**
 * @description
 *
 * Переключает класс у контейнера с текстом, который обрезает текст и добавляет многоточие
 *
 * @param {object} options -
 * @param {string} options.containerSelector - селектор контейнеров
 * @param {string} options.textSelector - селектор текстового узла внутри containerSelector
 * @param {number} options.limitHeight - ограничение высоты
 * @param {string} options.notLimitedClass - переключаемый класс
 */

function switchClassEllipsis(options = {}) {
  const {
    containerSelector,
    textSelector,
    limitHeight,
    notLimitedClass,
  } = options
  const containerElements = [...document.querySelectorAll(containerSelector)]

  containerElements.forEach(container => {
    const textElement = container.querySelector(textSelector)

    if (!textElement) {
      return
    }

    const method = textElement.scrollHeight <= limitHeight ? 'add' : 'remove'

    container.classList[method](notLimitedClass)
  })
}

export default switchClassEllipsis
